import { UAParser } from "ua-parser-js";
import moment from "moment";

function uploadLog(url, level, message) {
  var parser = new UAParser();
  var ua_object = parser.getResult();
  let row = {
    timestamp: moment().valueOf(),
    level: level,
    host: url.split("?")[0],
    parameters: url.split("?").length > 1 ? url.split("?")[1] : "",
    userAgent: window.navigator.userAgent,
    browser: ua_object.browser.name ? ua_object.browser.name : "",
    browserVersion: ua_object.browser.version ? ua_object.browser.version : "",
    os: ua_object.os.name ? ua_object.os.name : "",
    osVersion: ua_object.os.version ? ua_object.os.version : "",
    device: ua_object.device.name ? ua_object.device.name : "",
    deviceVersion: ua_object.device.version ? ua_object.device.version : "",
    ip: "",
    message: message,
  };

  fetch("https://api.ipify.org?format=json", {
    method: "GET",
    headers: { Accept: "application/json" },
  })
    .then((res) => {
      return res.json();
    })
    .then((json) => {
      row.ip = json.ip;
      // console.log(row);
      //API call

      fetch(
        "https://dvs7pjy01b.execute-api.ap-northeast-2.amazonaws.com/staging/notice-web/v1",
        {
          method: "PUT",
          body: JSON.stringify(row),
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
        .then((res2) => res2.text())
        .then((text) => {
          let str = Buffer.from(text, "base64").toString("utf8");
          let json = JSON.parse(str);
          // console.info(json);
        })
        .catch((error) => {
          console.info("error in ...");
          console.info(error);
        });
    })
    .catch((error) => {
      console.info("error in Log class");
      console.info(row);
      //API call
    }); //res.json()
}

export default uploadLog;
